import {
  useMemo
} from 'react';
import {
  isEmpty
} from '@shared/lib';
import {
  mapPaymentMethod,
  useGetPaymentMethodsQuery,
  type PaymentMethod,
} from '@entities/payments';

export type UseBackupPaymentMethodsProps = {
  paymentMethod: Maybe<PaymentMethod>;
};

export type UseBackupPaymentMethods = {
  isLoading: boolean;
  backups: Maybe<PaymentMethod[]>;
};

export const useBackupPaymentMethods = ({ paymentMethod }: UseBackupPaymentMethodsProps): {
  backupPaymentMethods: Maybe<Array<PaymentMethod>>;
  isLoading: boolean;
} => {
  const {
    isFetching: isLoading,
    data: response
  } = useGetPaymentMethodsQuery(undefined, {
    refetchOnMountOrArgChange: true
  });

  const backupPaymentMethods = useMemo(() => {
    if (isLoading || !response?.data) return null;

    const paymentMethods = response.data as unknown as Array<PaymentMethod>;
    if (isEmpty(paymentMethods)) return null;

    const filteredPaymentMethods = paymentMethods
      .map(paymentMethod => mapPaymentMethod(paymentMethod))
      .filter(({ key }) =>
        key === paymentMethod?.backupPayment1 ||
        key === paymentMethod?.backupPayment2
      );

    return isEmpty(filteredPaymentMethods) ? null : filteredPaymentMethods;
  }, [, paymentMethod, isLoading, response?.data]);

  return {
    isLoading,
    backupPaymentMethods,
  };
};